import { AverageDurationByTimeOfDayChart } from '../components/charts/AverageDurationByTimeOfDayChart';
import { AverageDurationByDayChart } from '../components/charts/AverageDurationByDayChart';
import { AverageDurationByDayOfWeekChart } from '../components/charts/AverageDurationByDayOfWeekChart';
import { AverageDurationByMonthChart } from '../components/charts/AverageDurationByMonthChart';

export const durationsChartConfig = {
  timeOfDay: {
    text: "Average duration by time of day",
    tooltip: "Breakdown of the average duration of guest connections over time of day.",
    ChartComponent: AverageDurationByTimeOfDayChart,
  },
  day: {
    text: "Average duration by day",
    tooltip: "Breakdown of the average duration of guest connections by day.",
    ChartComponent: AverageDurationByDayChart,
  },
  dayOfWeek: {
    text: "Average duration by day of the week",
    tooltip: "Breakdown of the average duration of guest connections over day of week.",
    ChartComponent: AverageDurationByDayOfWeekChart,
  },
  month: {
    text: "Average duration by month",
    tooltip: "Breakdown of the average duration of guest connections by month.",
    ChartComponent: AverageDurationByMonthChart,
  },
};